import {
  ApplicationRef,
  ComponentFactoryResolver,
  Directive,
  EmbeddedViewRef,
  HostListener,
  Injector,
  Input
} from '@angular/core';
import { GalleryComponent } from '../../components/gallery/gallery.component';
import { DynamicGalleryService } from '../../../core/services/dynamic-gallery/dynamic-gallery.service';
import { NativeAppService } from '@shared/common/services/native-app/native-app.service';
import { IPropertyImage } from '../../../core/interfaces/property';

@Directive({
  selector: '[appGallery]',
  standalone: false
})
export class GalleryDirective {
  @Input() album: IPropertyImage[];
  @Input() title: string;
  @Input() imageIndex: number;
  @Input() isShowTags: boolean;
  @Input() isOpenable = true;
  @Input() isRoomCategory = false;
  @Input() isHowItWorks = false;
  componentRef;

  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly appRef: ApplicationRef,
    private readonly injector: Injector,
    public dynamicGalleryService: DynamicGalleryService,
    private readonly nativeAppService: NativeAppService
  ) {}

  @HostListener('click')
  openAlbum(): void {
    if (!this.isOpenable) {
      return;
    }

    if (this.album.length) {
      this.dynamicGalleryService.album = this.album;
      this.dynamicGalleryService.title = this.title;
      this.dynamicGalleryService.imageIndex = this.imageIndex;
      this.dynamicGalleryService.isShowTags = this.isShowTags;
      this.dynamicGalleryService.isRoomCategory = this.isRoomCategory;
      this.dynamicGalleryService.isHowItWorks = this.isHowItWorks;
    }
    this.nativeAppService.notifyIntentToShowOverlay();
    this.appendComponentToBody(GalleryComponent);
    this.dynamicGalleryService.componentRef = this.componentRef;
  }

  appendComponentToBody(component: any) {
    this.componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);

    if (this.appRef) {
      this.appRef.attachView(this.componentRef.hostView);

      const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

      document.body.appendChild(domElem);
    }
  }
}
